import React from "react";
import { Box, Grid, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import {

  InfoOutlined,
  ManageAccountsOutlined,
} from "@mui/icons-material";

import { useTripDetailContext } from "contexts/TripDetailContext";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import Status from "components/Shared/Status";

const TripBasicDetail = () => {
  const { tripDetail, loadingTrip } = useTripDetailContext();

  return !loadingTrip ? (
    <Box padding={3}>
      <Grid container spacing={2}>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Trip ID"
            subtitle={tripDetail?.tripId}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <ManageAccountsOutlined color="primary" />}
            title="Driver Name"
            subtitle={tripDetail?.driver?.name}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Driver ID"
            subtitle={tripDetail?.driver?.driverId}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Vehicle ID"
            subtitle={tripDetail?.vehicle?.vehicle_id}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Vehicle Registration"
            subtitle={tripDetail?.vehicle?.registration_number}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Added By"
            subtitle={tripDetail?.addedBy?.name}
          />
        </Grid>
        <Grid item xs={3}>
          <InformationTile
            icon={() => <InfoOutlined color="primary" />}
            title="Active Status"
          >
            <Status isActive={tripDetail?.isActive} />
          </InformationTile>
        </Grid>
      </Grid>
      <Box mt={4}>
        <Box mb={2}>
          <Typography variant="h7" fontWeight="bold" color="text.primary">
            Route Details
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Source: {tripDetail?.sourceBranch?.name} ({tripDetail?.sourceBranch?.code}) 
            &nbsp;&nbsp;→&nbsp;&nbsp; 
            Destination: {tripDetail?.destinationBranch?.name} ({tripDetail?.destinationBranch?.code})
          </Typography>
        </Box>
        <TableContainer component={Paper} sx={{ boxShadow: "0 4px 12px rgba(0,0,0,0.05)", borderRadius: "8px" }}>
          <Table sx={{ minWidth: 650 }} aria-label="routes table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", color: "text.primary", py: 1.5 }}>Route Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "text.primary", py: 1.5 }}>Start Stop</TableCell>
                <TableCell sx={{ fontWeight: "bold", color: "text.primary", py: 1.5 }}>End Stop</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tripDetail?.routes?.map((route) => (
                <TableRow 
                  key={route._id} 
                  sx={{ 
                    "&:hover": { backgroundColor: "#fafafa" },
                    "&:last-child td, &:last-child th": { border: 0 }
                  }}
                >
                  <TableCell sx={{ py: 1.5 }}>{route.route.routeName}</TableCell>
                  <TableCell sx={{ py: 1.5 }}>{route.startStop.name} ({route.startStop.code})</TableCell>
                  <TableCell sx={{ py: 1.5 }}>{route.endStop.name} ({route.endStop.code})</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default TripBasicDetail;